export enum SseResponseEventEnum {
  error = 'error',
  answer = 'answer', // animation stream
  fastAnswer = 'fastAnswer', // direct answer text, not animation
  flowNodeStatus = 'flowNodeStatus', // update node status
  toolCall = 'toolCall', // tool start
  toolParams = 'toolParams', // tool params return
  toolResponse = 'toolResponse', // tool response return
  flowResponses = 'flowResponses', // sse response request
  updateVariables = 'updateVariables',
  appStreamResponse = 'appStreamResponse',
  info = 'info',
}
export const ExpiredTimeList = [
  { label: '7天', value: 7 },
  { label: '15天', value: 15 },
  { label: '30天', value: 30 },
  { label: '60天', value: 60 },
  { label: '永久', value: 0 },
]
export enum SessionStatuTypes {
  pending = 'pending',
  ready = 'ready',
  error = 'error',
  risk = 'risk',
}

export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const TAICHUAGENTSHAREUID = 'taichu_agent_share_uid'
